import React from "react";
import CalendarMonthOutlinedIcon from "@mui/icons-material/CalendarMonthOutlined";
import Select from "components/common/Select";
import Button from "components/common/Button";

import "./HolidayFilters.scss";

function HolidayFilters({
  selectedCountry,
  countryOptions,
  onCountryChange,
  onThisMonthClick,
  onAddToCalendarClick,
  isLoadingCalendar,
  userType,
}) {
  return (
    <div className="holiday-schedule-filters">
      {userType === "customer" && (
        <Select
          name="country"
          label="Country"
          options={countryOptions}
          value={selectedCountry}
          onChange={onCountryChange}
          placeholder="Select country"
        />
      )}
      {userType === "customer" && (
        <div className="flex gap-075 ml-auto">
          <Button label="This month" variant="outlined" onClick={onThisMonthClick} size="medium" />
          <Button
            label="Add to Calendar"
            variant="outlined"
            onClick={onAddToCalendarClick}
            size="medium"
            startIcon={<CalendarMonthOutlinedIcon />}
            isLoading={isLoadingCalendar}
            isDisabled={isLoadingCalendar}
          />
        </div>
      )}
    </div>
  );
}

export default HolidayFilters;
